import { formatNumber } from '@angular/common';
import { Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output } from '@angular/core';
import { SchoolViewModel } from 'src/app/models/school/schooladminitem.model';
import { SchoolInformationview } from 'src/app/models/schoolinformationview.model';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-progress-card',
  templateUrl: './progress-card.component.html',
  styleUrls: ['./progress-card.component.css']
})
export class ProgressCardComponent implements OnInit {
  @Input() module: any;
  @Input() hasMenu: boolean;
  @Input() url: string;
  @Input() queryParam: string;
  //@Input() livemeetinglink: string;
  //@Input() hasliveclass: string;
  @Input() type: string = 'course';
  @Input() inPackage: boolean = false;
  @Input() currentUserIsAdmin: boolean = false;
  @Output() deleteClicked: EventEmitter<any> = new EventEmitter<any>();
  typeString: string = '';
  //contentTypeString: string = '';

  modaltargetId: string;
  modalId: string;

  //school: SchoolInformationview
  school: SchoolViewModel = new SchoolViewModel();

  constructor(@Inject(LOCALE_ID) public locale: string, 
  public headerService: ComponentheaderService, 
  private util: UtilService,
  public useraccessservice: UseraccessserviceService) { 
  }

  get contentTypeString(): string{
    switch(this.type){
      case 'course':
        return this.module.lessonCount == 1 ? 'lesson' : 'lessons';
      case 'package':
        return this.module.courseCount == 1 ? 'course' : 'courses';
      default:
        this.typeString = '';
    }
  }

  ngOnInit(): void {
    this.school = this.util.schoolInfoBundle.schoolInfo;
    //debugger;
    //console.log(this.currentUserIsAdmin);
    this.modalId = `modal_${this.module.id}`;
    this.modaltargetId = `#${this.modalId}`;
    console.log(this.module);

    switch(this.type){
      case 'course':
        this.typeString = 'course';
        //this.contentTypeString = 'Lessons';
        //debugger;
        break;
      case 'package':
        this.typeString = 'package';
        //this.contentTypeString = 'Courses';
        break;
      default:
        this.typeString = '';
    }
  }

  get title(): string{
    switch(this.type){
      case 'course':
        return this.module.courseTitle;
        break;
      case 'package':
        return this.module.name;
        break;
      default:
        return '';
    }
  }

  get contentCount(): number{
    switch(this.type){
      case 'course':
        return this.module.lessonCount;
        break;
      case 'package':
        return this.module.courseCount;
        break;
      default:
        return 0;
    }
  }

  get price(): number {
    switch (this.type) {
      case 'course':
        return this.module.price;
        break;
      case 'package':
        return this.module.amountPerStudent;
        break;
      default:
        return 0;
    }
  }

  get accessDays(): number {
    switch (this.type) {
      case 'course':
        return this.module.accessDays;
        break;
      case 'package':
        return this.module.accessdays;
        break;
      default:
        return 0;
    }
  }

  deleteButtonClicked(){
    this.deleteClicked.emit(this.module);
  }

  formatNumber(_number: number){
    return formatNumber(_number, this.locale);
  }

}
